module.exports = __webpack_public_path__ + "docs/cgw-interfaces-1.2.pdf";